import dashRoutes from "./dashRoutes";
import authRoutes from "./authRoutes";

const routes = [...dashRoutes, ...authRoutes];

export default routes;
